// Whether this browser has signed in with Microsoft before (docs/Auth-Flows.md,
// "Which screen /login shows"). From the cutoff, /login sends such a browser
// straight to Microsoft's sign-in page instead of the page that explains the
// move. Only the fact is kept, never the email: ward computers are shared.
// Signing out keeps it, since it describes the browser, not the user.

const MIGRATED_KEY = 'mashlom.entra.migrated';

export const markMigrated = (): void => {
  try {
    localStorage.setItem(MIGRATED_KEY, '1');
  } catch {
    // Storage blocked (private mode): /login shows the explanation, which still works.
  }
};

export const hasMigrated = (): boolean => {
  try {
    return localStorage.getItem(MIGRATED_KEY) === '1';
  } catch {
    return false;
  }
};
